<app-progress-indicator [inProgress]="isLoading"></app-progress-indicator>
<router-outlet></router-outlet>
